import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { getWhatsAppUrl } from '../utils/whatsapp';
const services = [{
  category: 'Mujer',
  items: [{
    name: 'Cuerpo completo',
    price: 2000
  }, {
    name: 'Piernas',
    price: 1200
  }, {
    name: 'Axilas',
    price: 800
  }, {
    name: 'Zona íntima',
    price: 650
  }, {
    name: 'Tira de cola',
    price: 650
  }, {
    name: 'Bozo y mentón',
    price: 650
  }]
}, {
  category: 'Hombre',
  items: [{
    name: 'Cuerpo completo',
    price: 2500
  }, {
    name: 'Pecho y abdomen',
    price: 1200
  }, {
    name: 'Espalda',
    price: 1200
  }, {
    name: 'Barba',
    price: 800
  }]
}];
export const Services = () => {
  return <section className="py-12 sm:py-20 bg-slate-50" id="servicios" data-id="element-223">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-224">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-225">
          <h2 className="text-2xl sm:text-3xl font-bold text-navy-900 mb-4" data-id="element-226">
            Nuestros Servicios
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-227">
            Precios transparentes por sesión. Consultá por packs promocionales.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-228">
          {services.map((group, groupIndex) => <motion.div key={group.category} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: groupIndex * 0.2
        }} data-id="element-229">
              <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center gap-3" data-id="element-230">
                {group.category}
                <div className="h-px bg-slate-200 flex-1" data-id="element-231"></div>
              </h3>

              <div className="space-y-4" data-id="element-232">
                {group.items.map((service, index) => <div key={index} className="group bg-white rounded-2xl p-5 sm:p-6 shadow-sm border border-slate-100 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:border-brand-200 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200" data-id="element-233">
                    <div data-id="element-234">
                      <h4 className="text-lg font-bold text-slate-800" data-id="element-235">
                        {service.name}
                      </h4>
                    </div>

                    <div className="flex items-center justify-between sm:justify-end gap-6 w-full sm:w-auto" data-id="element-236">
                      <div className="text-2xl font-extrabold text-brand-600 transition-transform duration-200 group-hover:scale-110 origin-left sm:origin-right" data-id="element-237">
                        ${service.price}
                      </div>
                      <a href={getWhatsAppUrl(`Hola! Me gustaría consultar por el servicio de ${service.name} (${group.category}).`)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-brand-700 bg-brand-50 hover:bg-brand-600 hover:text-white hover:shadow-lg hover:shadow-brand-500/30 hover:-translate-y-0.5 active:scale-95 px-4 py-2 rounded-full transition-all duration-200" data-id="element-238">
                        <MessageCircle className="w-4 h-4" data-id="element-239" />
                        Consultar
                      </a>
                    </div>
                  </div>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};